import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Boxes } from "lucide-react";

const DEMO = [
  ["admin@netstar.co.za", "System Admin"],
  ["warehouse@netstar.co.za", "Warehouse Mgr"],
  ["regional@netstar.co.za", "Regional Mgr"],
  ["ops@netstar.co.za", "Operations"],
  ["finance@netstar.co.za", "Finance"],
  ["tech@netstar.co.za", "Technician"],
];

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@netstar.co.za");
  const [password, setPassword] = useState("Admin@123");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (e) {
      setErr(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" style={{ background: "#0B2545" }}>
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-16 text-white">
        <div className="font-head text-3xl font-bold tracking-widest">NETSTA<span style={{ color: "#00857C" }}>R</span></div>
        <div>
          <div className="overline mb-3" style={{ color: "#00857C" }}>Consignment Stock Platform</div>
          <h1 className="font-head text-5xl font-bold leading-tight">Serialised stock,<br />from bin to vehicle.</h1>
          <p className="text-slate-300 mt-4 max-w-md">Track every consignment unit across the main bin, regional warehouses, fitment centres and in-house technicians — in real time.</p>
        </div>
        <div className="text-slate-400 text-xs">Confidential — Netstar Consignment Stock Pilot</div>
      </div>
      <div className="flex-1 flex items-center justify-center bg-[#F4F5F7] p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 mb-6 lg:hidden">
            <Boxes className="text-[#00857C]" /> <span className="font-head font-bold text-xl text-[#0B2545]">NETSTAR</span>
          </div>
          <h2 className="font-head text-2xl font-bold text-[#0B2545] mb-1">Sign in</h2>
          <p className="text-sm text-slate-500 mb-6">Use your Netstar operations account.</p>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label className="overline text-slate-500">Email</Label>
              <Input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm focus-visible:ring-[#00857C]" />
            </div>
            <div className="space-y-1.5">
              <Label className="overline text-slate-500">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-sm focus-visible:ring-[#00857C]" />
            </div>
            {err && <div data-testid="login-error" className="text-sm text-red-600">{err}</div>}
            <Button data-testid="login-submit" disabled={loading} className="w-full rounded-sm bg-[#00857C] hover:bg-[#00a89d] font-head">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
            </Button>
          </form>
          <div className="mt-6">
            <div className="overline text-slate-400 mb-2">Quick demo login</div>
            <div className="grid grid-cols-2 gap-2">
              {DEMO.map(([em, label]) => (
                <button key={em} data-testid={`demo-${em}`} onClick={() => { setEmail(em); setPassword(em.startsWith("admin") ? "Admin@123" : "Pass@123"); }}
                  className="text-left text-xs border border-slate-200 rounded-sm px-2.5 py-2 hover:border-[#00857C] hover:text-[#00857C] transition-colors">
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
